// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__6RFZO","searchIcon":"Select_searchIcon__1Sv6S","expandIcon":"Select_expandIcon__2WJaK"};